 
    // const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';  //local 
    // const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://beta-api.svmsweets.com/api';

    const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://billingapi.svmsweets.com/api'; // live

    export default API_BASE_URL;
